import { useMutation } from '@tanstack/react-query';
import { modemApis } from '../../../../../../shared/apis/modem/apis';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';
import Swal from 'sweetalert2';

export default function useDeleteModems() {
  return useMutation(modemApis.deleteModems, {
    onError: (error: AxiosError<AxiosCommonError>) => {
      if (error.response?.data.httpStatus === 'BAD_REQUEST') {
        const errorMessage = error.response?.data.errorMessage?.split('-');
        const mac = errorMessage?.[1];
        const temp = errorMessage?.[0].split('_');
        const service = temp?.[temp.length - 1];

        Swal.fire({
          title: '디바이스 삭제 실패',
          text: `${mac}은 ${service} 서비스에서 사용 중입니다.`,
          icon: 'error',
          confirmButtonText: '확인',
        });
        return;
      }
      handleError(error);
    },
  });
}
